import React from 'react';
import {withStore} from "../../hocs";
import {observer} from "mobx-react";

const PHONE_MASK = '+375 (99) 999-99-99';
const DIGITS_ONLY = /\d/g;

function formatPhone(value: string): string {
    const digits = (value || '').match(DIGITS_ONLY)?.join('').slice(0, 9) || '';
    if (digits.length === 0) return '';
    let i = 0;
    return PHONE_MASK.replace(/\d/g, () => digits[i++] ?? '');
}

// @ts-ignore
@withStore
@observer
export class AnyQuestions extends React.Component {

    render() {
        // @ts-ignore
        const {store} = this.props;

        const {
            onChangeNameForBitrix,
            onChangePhoneForBitrix,
            onChangeTestForBitrix,
            sendMessage,
            isModalOpen,
            onCloseModal,
            phoneForBitrix,
            nameForBitrix,
            textForBitrix
        } = store?.pagePersonalStore;


        return (
            <>
                <section className="any-questions">
                    <div className="container">
                        <h2 className="any-questions__title">Остались вопросы?</h2>
                        <p className="any-questions__description">Мы вам перезвоним!</p>
                        <div className="form any-questions__form">
                            <p className="form__item">
                                <label className="visually-hidden" htmlFor="person-name" />
                                <input value={nameForBitrix} className="text-field" type="text" placeholder="Ваше имя" id="person-name" onChange={event => (onChangeNameForBitrix(event))} />
                            </p>
                            <p className="form__item">
                                <label className="visually-hidden" htmlFor="person-phone" />

                                <input
                                    value={phoneForBitrix}
                                    className="text-field"
                                    type="tel"
                                    placeholder="Телефон"
                                    id="person-phone"
                                    onChange={(e) => {
                                        const formatted = formatPhone(e.target.value);
                                        onChangePhoneForBitrix({ target: { value: formatted } } as any);
                                    }}
                                />
                            </p>
                            <p className="form__item">
                                <label className="visually-hidden" htmlFor="person-test" />
                                <input value={textForBitrix} className="text-field" type="text" placeholder="Текст сообщения" id="person-text" onChange={event => (onChangeTestForBitrix(event))} />
                            </p>

                            <button className="button button--accent-light any-questions__button" onClick={()=> sendMessage()}>
                                Отправить
                            </button>
                        </div>
                    </div>
                </section>

                <div className={isModalOpen ? "modal modal--success is-open" : "modal modal--success"}  data-modal="isModalOpen2">
                    <button className="modal__close js--modal-close"
                            onClick={() => onCloseModal()}
                            type="button">
                        <span className="visually-hidden">Закрыть модальное окно</span>
                        <span className="modal__close-icon" />
                    </button>
                    <div className="modal__body modal__body--clear">
                        <svg className="modal__icon" width="31" height="27">
                            <use xlinkHref="/images/sprite.svg#icon--comment"/>
                        </svg>
                        <h2 className="modal__title modal__title--order-success accent-text">Внимание!</h2>
                        <p className="modal__body-text">
                            Для отправки сообщения необходимо заполнить все поля
                        </p>
                        <span className="button button--accent-dark modal__button js--modal-close"
                              onClick={() => onCloseModal()}>Вернуться</span>
                    </div>
                </div>
            </>
        )
    }
}
